<template>
  <div class="DiscussionReportFilterBar">
    <div class="container-fluid">
      <div class="row vertical-align margin-Top-2Perc margin-bottom-2Perc">
        <div class="col-md-2 col-lg-2">
        </div>
        <div class="col-md-2 col-lg-2 padding-left-3Point3Perc padding-right-0Px text-align-right">
          Group Course(s):
        </div>    
        <div class="col-md-4 col-lg-4">
          <div class="form-group">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-left-right-0Px">
              <select class="form-control" v-model="selectedGroupCourseObj">
                <option value='-1' disabled>Select</option>
                <option v-for="groupCourseObj in groupCourseListValue" v-bind:key="groupCourseObj.GroupCourseMasterId" v-bind:value="groupCourseObj" v-if="showOption(groupCourseObj)">{{ groupCourseObj.GroupName }} :: {{groupCourseObj.CourseTitle}} {{groupCourseObj.CourseSubTitle !== null && groupCourseObj.CourseSubTitle.trim().length !== 0 ? '[' + groupCourseObj.CourseSubTitle + ']': ''}}</option>
              </select> 
            </div>
          </div>
        </div>
        <div class="col-md-4 col-lg-4">
        </div>
    </div>
    <div class="row vertical-align margin-Top-2Perc margin-bottom-2Perc"> 
        <!-- <div class="col-md-1 col-lg-1 width-3Perc"></div> -->
        <div class="col-md-1 col-lg-1 padding-left-3Point3Perc padding-right-0Px text-align-left">
          Cohort(s):
        </div>    
        <div class="col-md-4 col-lg-4">
          <div class="form-group">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-left-right-0Px">
              <select class="form-control" v-model="selectedCohortObj">
                <option value='-1' disabled>Select</option>
                <option v-for="cohortObj in getAssociatedCohorts" v-bind:key="cohortObj.CohortId" v-bind:value="cohortObj">{{ cohortObj.CohortName }}</option>
              </select> 
            </div>
          </div>
        </div>
        <div class="col-md-1 col-lg-1 text-align-right">
          Lesson(s):
        </div>    
        <div class="col-md-4 col-lg-4 padding-left-0Perc text-align-left">
          <div class="form-group">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-left-right-0Px">
              <select class="form-control" v-model="selectedMOTDObj">
                <option value=-1 disabled>Select</option>
                <option v-for="currMOTDObj in getMOTDList" v-bind:key="currMOTDObj.ModuleId" v-bind:value="currMOTDObj" v-if="!currMOTDObj.IsBonusContent">{{currMOTDObj.Title}}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-md-1 col-lg-1 padding-right-0Px padding-left-0Perc">
          <!-- ToDo: Track this -->
          <button class="btn btn-primary btn-block unenroll-existing-button-BG black-font-color" v-on:click="checkAndEmit($event, false)">View</button>
        </div>
        <div class="col-md-1 col-lg-1 padding-right-0Px">
          <button class="btn btn-primary btn-block unenroll-existing-button-BG black-font-color padding-6px-6px" v-on:click="checkAndEmit($event, true)" v-if="getShowExportState">Export</button>
        </div>
      </div>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
    <!-- Show Spinner -->
    <div class="animationload" v-show="showSpinner">
      <div class="osahanloading"></div>
    </div>
    <loader></loader>      
  </div>
</div>    
</template>

<script>
import isEqual from 'lodash/isEqual'
import { constants } from '@/utils/constants'
import { groupCourseService } from '@/server-util/group-course-service'
import { cohortService } from '@/server-util/cohort-service'
import { moduleService } from '@/server-util/module-service'
import AlertBox from '@/components/AlertOverlay'
import Loader from '@/components/dashboard/Loader'
import isEmpty from 'lodash/isEmpty'
export default {
  props: ['showExport'],
  created: function () {
    this.setDefaultValues()
    this.getAllGroupCourses()
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      groupObj: -1,
      selectedMOTDObj: -1,
      selectedGroupCourseObj: -1,
      selectedCohortObj: -1,
      associatedCohortList: [],
      locaMOTDList: []
    }
  },
  methods: {
    showOption: function (groupCourseObj) {
      if (groupCourseObj.ReleaseTS !== null && groupCourseObj.ReleaseTS !== 'null' && groupCourseObj.ReleaseTS !== '' && groupCourseObj.ReleaseTS !== undefined && groupCourseObj.ExpiryDays !== null && groupCourseObj.ExpiryDays !== 'null' && groupCourseObj.ExpiryDays !== '' && groupCourseObj.ExpiryDays !== undefined) {
        return true
      } else {
        return false
      }
    },
    getLessons: function () {
      var storeObj = this.$store
      if (this.selectedGroupCourseObj !== -1) {
        var courseMasterId = this.selectedGroupCourseObj.CourseMasterId
        moduleService.listModules(storeObj.state.access_token, courseMasterId)
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                this.locaMOTDList = responseObj.data
                this.$store.state.isLoading = false
                if (this.locaMOTDList.length === 0) {
                  this.showAlertDialog = true
                  var subTitleName = this.selectedGroupCourseObj.CourseSubTitle === null ? '' : ' [' + this.selectedGroupCourseObj.CourseSubTitle + ']'
                  this.errorMsg = 'No Lesson(s) found in \'' + this.selectedGroupCourseObj.CourseTitle + subTitleName + '\'.'
                }
              } else {
                // this.showSpinner = false
                this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
              }
            }, errorObj => {
              // this.showSpinner = false
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
      } else {
        console.log('No Group Course found hence declined Lesson loading operation.')
      }
    },
    setDefaultValues: function () {
      if (!isEmpty(this.$store.state.selectedGroupCourseObj)) {
        if (this.$store.state.selectedGroupCourseObj.GroupId === this.getselectedGroupCourseObj.GroupId) {
          this.selectedGroupCourseObj = this.$store.state.selectedGroupCourseObj
        } else {
          this.selectedGroupCourseObj = -1
        }
      }
      if (!isEmpty(this.$store.state.selectedCohortObj)) {
        if (this.selectedGroupCourseObj !== -1) {
          this.selectedCohortObj = this.$store.state.selectedCohortObj
        } else {
          this.selectedCohortObj = -1
        }
      }
    },
    checkAndEmit: function (event, isExportBtnClicked) {
      if (this.selectedGroupCourseObj !== -1) {
        if (this.selectedCohortObj !== -1) {
          if (this.selectedMOTDObj !== -1) {
            // AK: Emit selected MOTD, Group Course and cohort obj
            this.$emit('selectedMOTDObj', this.selectedMOTDObj)
            this.$emit('selectedGroupObj', this.selectedGroupCourseObj)
            this.$emit('selectedCohortObj', this.selectedCohortObj)
            this.$store.state.selectedGroupCourseObj = this.selectedGroupCourseObj
            this.$store.state.selectedCohortObj = this.selectedCohortObj
            if (isExportBtnClicked) {
              this.$emit('isExportBtnClicked', true)
              this.$emit('isViewBtnClicked', false)
            } else {
              this.$emit('isExportBtnClicked', false)
              this.$emit('isViewBtnClicked', true)
            }
          } else {
            this.showAlertDialog = true
            if (this.locaMOTDList.length === 0) {
              var subTitleName = this.selectedGroupCourseObj.CourseSubTitle === null ? '' : ' [' + this.selectedGroupCourseObj.CourseSubTitle + ']'
              this.errorMsg = 'No Lesson(s) found in \'' + this.selectedGroupCourseObj.CourseTitle + subTitleName + '\'.'
            } else {
              this.errorMsg = 'Please select a Lesson(s).'
            }
          }
        } else {
          this.showAlertDialog = true
          this.errorMsg =
            'Please select a cohort.'
        }
      } else {
        this.showAlertDialog = true
        this.errorMsg =
          'Please select a group course.'
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    getAssociatedCohortList: function () {
      var storeObj = this.$store
      var _this = this
      if (
        this.selectedGroupCourseObj !== -1
      ) {
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        cohortService
          .getCohortListUsingGroupCourse(
            storeObj.state.access_token,
            this.selectedGroupCourseObj.GroupCourseMasterId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner after recieving Cohort list response
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              if (responseObj.data.length === 0) {
                this.showAlertDialog = true
                var subTitleName = this.selectedGroupCourseObj.CourseSubTitle === null ? '' : ' [' + this.selectedGroupCourseObj.CourseSubTitle + ']'
                this.errorMsg = 'No cohort found in \'' + this.selectedGroupCourseObj.GroupName + ' :: ' + this.selectedGroupCourseObj.CourseTitle + subTitleName + '\'.'
                this.selectedCohortObj = -1
              }
              this.associatedCohortList = responseObj.data
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // AK: Hide Spinner if error occured
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner if error occured
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Select Group ID is NULL hence declined LISTING Associated Cohort(s) OPERATION'
        )
      }
    },
    getAllGroupCourses: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined || storeObj.state.access_token !== ''
      ) {
        // AK: If group courses are not available then only show spinner
        if (storeObj.state.groupCourseList.length === 0) {
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
        }
        groupCourseService
          .getGroupCourseList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.groupCourseList = responseObj.data
              if (this.$store.state.isLoading === true) {
                // AK: Hide Spinner after recieving Group Course list
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              if (_this.$store.state.isLoading === true) {
                // AK: Hide Spinner after recieving Group Course list
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            }
          }, errorObj => {
            if (_this.$store.state.isLoading === true) {
              // AK: Hide Spinner after recieving Group Course list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined GROUP COURSE LISTING OPERATION'
        )
      }
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader
  },
  computed: {
    getMOTDList: {
      get: function () {
        return this.locaMOTDList
      }
    },
    groupCourseListValue: {
      get: function () {
        return this.$store.state.groupCourseList
      }
    },
    getAssociatedCohorts: {
      get: function () {
        return this.associatedCohortList
      }
    },
    getSelectedCohortObj: {
      get: function () {
        return this.selectedCohortObj
      }
    },
    getShowExportState: {
      get: function () {
        return this.showExport
      }
    }
  },
  watch: {
    selectedGroupCourseObj: function () {
      // AK: Reset Selected Cohort Obj to -1 again
      if (!isEqual(this.selectedGroupCourseObj, this.$store.state.selectedGroupCourseObj)) {
        this.selectedCohortObj = -1
        this.selectedMOTDObj = -1
        this.locaMOTDList = []
      }
      this.getAssociatedCohortList()
      this.getLessons()
    }
  },
  name: 'DiscussionReportFilterBar'
}
</script>

<style scoped>
.DiscussionReportFilterBar {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.padding-left-right-0Px {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.btn {
  white-space: normal !important;
  word-wrap: break-word;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.white-BG {
  background-color: #ffffff;
}
.MainDiv {
  overflow-y: hidden !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}

.align-center {
  margin: 0 auto !important;
}
.left-border {
  border-left: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.black-border {
  border: 1px solid black;
}
.grey-border {
  border: 1px solid #aaa;
}
.center-block {
  float: none;
  margin-left: auto;
  margin-right: auto;
}
.cursor-pointer {
  cursor: pointer;
}
.text-align-left {
  text-align: left !important;
}
.font-size-20px {
  font-size: 20px;
}
.font-weight-bold {
  font-weight: bold;
}
.width {
  width: 5%;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.float-right {
  float: right;
}
.unenroll-existing-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color {
  color: #000;
}
.text-align-right {
  text-align: right !important;
}
.border-red {
  border: 1px solid red;
}
.padding-6px-6px{
  padding: 6px 6px;
}
.width-auto {
  width: auto;
}
.padding-left-2Point5Perc {
  padding-left: 2.5%;
}
.padding-left-3Perc {
  padding-left: 3%;
}
.width-3Perc {
  width: 3%;
}
.width-13Point4Perc {
  width:13.4%;
}
.padding-left-0Perc {
  padding-left: 0%;
}
.padding-left-3Point3Perc {
  padding-left:3.3%;
}
</style>


// WEBPACK FOOTER //
// src/components/reports/m365_report/m365ReportFilterBar.vue